import { render, staticRenderFns } from "./FintechBody.vue?vue&type=template&id=76db9890&scoped=true&"
import script from "./FintechBody.vue?vue&type=script&lang=js&"
export * from "./FintechBody.vue?vue&type=script&lang=js&"
import style0 from "./FintechBody.vue?vue&type=style&index=0&id=76db9890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76db9890",
  null
  
)

export default component.exports